import { config } from "../../config";

/**
 * Fetches the first user marketing profile associated with a personal user offer
 * @param personalUserOfferId The personal user offer ID
 * @param emitEventCallback Optional callback to emit events
 * @returns The user marketing profile data or null if not available
 */
export async function fetchFirstUMPofPUOonUMPO(
  personalUserOfferId: string | null,
  emitEventCallback?: (eventName: string, data: any) => void
): Promise<any> {
  if (!personalUserOfferId) {
    return null;
  }

  try {
    if (config.env === "development") {
      console.debug(
        "MonitoringService: Fetching first user marketing profile for personal user offer ID:",
        personalUserOfferId
      );
    }

    const response = await fetch(
      `${config.backend.base_url}/UserMarketingProfileOffer/GetFirstUserMarketingProfileForOffer`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          personalUserOfferId: personalUserOfferId,
        }),
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const profileData = await response.json();

    if (config.env === "development") {
      console.debug("MonitoringService: Fetched User Marketing Profile Data", {
        profileData: profileData,
      });
    }

    // Emit event if callback provided
    if (emitEventCallback) {
      emitEventCallback("user_marketing_profile_fetched", {
        success: true,
        data: profileData,
      });
    }

    return profileData.type === "SUCCESS" ? profileData.data : null;
  } catch (error) {
    if (config.env === "development") {
      console.error(
        "MonitoringService: Failed to fetch user marketing profile:",
        error
      );
    }

    // Emit error event if callback provided
    if (emitEventCallback) {
      emitEventCallback("user_marketing_profile_fetched", {
        success: false,
        error: error instanceof Error ? error.message : "Unknown error",
      });
    }

    throw error;
  }
}
